exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuestionComponent{margin:1rem 0;padding:0 28px}.vdialog-question-comp table{border:1px solid;width:100%}.vdialog-question-comp td,.vdialog-question-comp th{border:1px solid}", ""]);

// exports
